import {useEffect, useState, useContext,useRef} from 'react'
import { DataContext } from "../../../context/DataContext";
import { petitions } from "../../../api/calls";
import { toast } from "sonner";
import {useForm} from 'react-hook-form'
import Swal from 'sweetalert2';

export default function Categoria() {
  const {session, idEmpresa } = useContext(DataContext);
  const [categoria, setCategoria] = useState([])
  const [TPServicio, setTPServicio] = useState([])

  const [estCategoria, setEstCategoria] = useState(false)
  const [estTPServicio, setEstTPServicio] = useState(false)

  //MODALS
  const modalRef1 = useRef(null);
  const closeModal1 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef1.current);
    modalInstance.hide();
  };

  const modalRef2 = useRef(null);
  const closeModal2 = () => {
    const modalInstance = window.bootstrap.Modal.getInstance(modalRef2.current);
    modalInstance.hide();
  };

  //FILTROS
  const [searchCategoria, setSearcCategoria] = useState("")
  const filteredCategoria = categoria.filter((obj) =>
    obj.nombre.toLowerCase().includes(searchCategoria.toLowerCase())
  );

  const [searchTPServicio, setSearchTPServicio] = useState("")

  const filteredTPServicio = TPServicio.filter((obj) =>
    obj.descripcion.toLowerCase().includes(searchTPServicio.toLowerCase())
  );

  const form1 = useForm()
  const form2 = useForm()

  useEffect(() => {
    const fetchCategoria = async () => {
      const response = await petitions.getCategoria(idEmpresa(), session().token);

      if (response.status === "success") {
        setCategoria(response.data);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchCategoria();
  }, [estCategoria, session, idEmpresa]);

  useEffect(() => {
    const fetchTPServicio = async () => {
      const response = await petitions.getTPServicio(idEmpresa(), session().token);

      if (response.status === "success") {
        setTPServicio(response.data);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPServicio();
  }, [estTPServicio, session, idEmpresa]);


  const sendCategoria = form1.handleSubmit(async (data) =>{ 
    const response = await petitions.insertCategoria(idEmpresa(), session().token,data)
    if (response.status === "success") {
      if (response.data) {
        closeModal1()
        toast.success("Categoria registrada correctamente");
        setEstCategoria(!estCategoria)
        form1.reset()
      }
      else{
        closeModal1()
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      closeModal1()
      const msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const deleteCategoria = (idCategoria) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
    
    swalWithBootstrapButtons.fire({
      title: "Estas seguro/a?",
      text: "No podrás cancelar el proceso",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "No, cancelar",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await petitions.deleteCategoria(idEmpresa(), session().token, {idCategoria})
        if (response.status === "success") {
          if (response.data) {
            setEstCategoria(!estCategoria)
            toast.success("Categoria eliminada correctamente")
          }
          else{
            toast.warning("Ocurrió un problema, inténtelo mas tarde");  
          }
        } else {
          var msg = typeof response.code === "string" ? response.message : response.data;
          toast.error(msg);
        }
      }
    });
  }

  const sendTPServicio = form2.handleSubmit(async (data) =>{
    const response = await petitions.insertTPServicio(idEmpresa(), session().token, data)
    if (response.status === "success") {
      if (response.data) {
        closeModal2()
        form2.reset()
        setEstTPServicio(!estTPServicio)
        toast.success("Clasificación registrada correctamente")
      }
      else{
        closeModal2()
        toast.warning("Ocurrió un problema, inténtelo mas tarde");  
      }
    } else {
      closeModal2()
      var msg = typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  })

  const deleteTPServicio = async (idTPservicio) => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger"
      },
      buttonsStyling: false
    });
    
    swalWithBootstrapButtons.fire({
      title: "Estas seguro/a?",
      text: "No podrás cancelar el proceso",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, eliminar",
      cancelButtonText: "No, cancelar",
      reverseButtons: true
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await petitions.deleteTPServicio(idEmpresa(), session().token,{idTPservicio})
        if (response.status === "success") {
          if (response.data) {
            setEstTPServicio(!estTPServicio)
            toast.success("Clasificación eliminado correctamente")
          }
          else{
            toast.warning("Ocurrió un problema, inténtelo mas tarde");  
          }
        } else {
          var msg = typeof response.code === "string" ? response.message : response.data;
          toast.error(msg);
        }
      }
    });
  }

  return (
    <>
      <div className="row gy-3 mb-4 justify-content-between">
        <div className="col-md-9 col-auto">
          <h2 className="mb-2 text-body-emphasis">
            Categoria y clasificación de producto
          </h2>
          <h5 className="text-body-tertiary fw-semibold">
            Gestiona las categorias de tus productos y dales una clasificación
            para tener una mayor personalización.
          </h5>
        </div>
      </div>
      <div className="mx-lg-n4 mt-3">
        <div className="row g-3">
          <div className="col-12 col-xl-6 col-xxl-7">
            <div className="card todo-list h-100 rounded-4">
              <div className="card-header border-bottom-0 pb-0">
                <div className="row justify-content-between align-items-center mb-4">
                  <div className="col-auto">
                    <h3 className="text-body-emphasis">Categoria</h3>
                    <p className="mb-0 text-body-tertiary">
                      Categorias disponibles en tu empresa
                    </p>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div className="col-auto w-100 w-md-auto">
                    <div className="row align-items-center g-0 justify-content-between">
                      <div className="col-12 col-sm-auto">
                        <div
                          className="search-box w-100 mb-2 mb-sm-0"
                          style={{ maxWidth: "30rem" }}
                        >
                            <input
                              className="form-control search-input search rounded-4"
                              type="search"
                              placeholder="Buscar categorias"
                              aria-label="Search"
                              onChange={(event) => {setSearcCategoria(event.target.value)}}
                            />
                            <span className="fas fa-search search-box-icon"></span>
                        </div>
                      </div>
                      <div className="col-auto d-flex">
                        <p className="mb-0 ms-sm-3 fs-9 text-body-tertiary fw-bold">
                          <span className="fas fa-filter me-1 fw-extra-bold fs-10"></span>
                          {categoria.length} categorias
                        </p>
                        <div
                          className={
                            "btn btn-link p-0 ms-3 fs-9 text-" +
                            (categoria.length > 0 ? "primary" : "danger") +
                            " fw-bold"
                          }
                        >
                          <span className="fas fa-sort me-1 fw-extra-bold fs-10"></span>
                          Estado
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 scrollbar to-do-list-body">
                {filteredCategoria &&
                  filteredCategoria.map((c) => (
                    <div
                      className="d-flex hover-actions-trigger py-3 border-top"
                      key={c.idCategoria}
                    >
                      <div className="row justify-content-between align-items-md-center btn-reveal-trigger border-translucent gx-0 flex-1">
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="mb-1 mb-md-0 d-flex align-items-center lh-1">
                            <label className="form-check-label mb-1 mb-md-0 mb-xl-1 mb-xxl-0 fs-8 me-2 line-clamp-1 text-body">
                              {c.nombre}
                            </label>
                            <button className="badge badge-phoenix ms-auto fs-10 badge-phoenix-info" disabled={true} style={{display:"none"}}>
                              editar
                            </button>
                            <button className="badge badge-phoenix ms-auto ms-2 fs-10 badge-phoenix-danger rounded-4" onClick={()=>{deleteCategoria(c.idCategoria)}}>
                              eliminar
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="d-flex lh-1 align-items-center">
                            <div className="hover-md-hide hover-xl-show hover-xxl-hide">
                              <p className="text-body-tertiary fs-10 fw-bold mb-md-0 mb-0 ps-md-3 ps-xl-0 ps-xxl-3 border-start-md border-xl-0 border-start-xxl">
                                {}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer border-0">
                <a
                  className="fw-bold fs-9 mt-4"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAgregarCategoria"
                >
                  <span className="fas fa-plus me-1"></span>Agregar nueva categoria
                </a>
              </div>
            </div>
          </div>
          <div className="col-12 col-xl-6 col-xxl-7">
            <div className="card todo-list h-100 rounded-4">
              <div className="card-header border-bottom-0 pb-0">
                <div className="row justify-content-between align-items-center mb-4">
                  <div className="col-auto">
                    <h3 className="text-body-emphasis">Clasificación de producto</h3>
                    <p className="mb-0 text-body-tertiary">
                      Revise los tipo de clasificación disponibles en tu empresa
                    </p>
                  </div>
                  <br />
                  <br />
                  <br />
                  <div className="col-auto w-100 w-md-auto">
                    <div className="row align-items-center g-0 justify-content-between">
                      <div className="col-12 col-sm-auto">
                        <div
                          className="search-box w-100 mb-2 mb-sm-0"
                          style={{ maxWidth: "30rem" }}
                        >
                            <input
                              className="form-control search-input search rounded-4"
                              type="search"
                              placeholder="Buscar clasificaciones"
                              aria-label="Search"
                              onChange={(event) => {setSearchTPServicio(event.target.value)}}
                            />
                            <span className="fas fa-search search-box-icon"></span>
                        </div>
                      </div>
                      <div className="col-auto d-flex">
                        <p className="mb-0 ms-sm-3 fs-9 text-body-tertiary fw-bold">
                          <span className="fas fa-filter me-1 fw-extra-bold fs-10"></span>
                          {TPServicio.length} clasificaciones
                        </p>
                        <div
                          className={
                            "btn btn-link p-0 ms-3 fs-9 text-" +
                            (categoria.length > 0 ? "primary" : "danger") +
                            " fw-bold"
                          }
                        >
                          <span className="fas fa-sort me-1 fw-extra-bold fs-10"></span>
                          Estado
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 scrollbar to-do-list-body">
                {filteredTPServicio &&
                  filteredTPServicio.map((p) => (
                    <div
                      className="d-flex hover-actions-trigger py-3 border-top"
                      key={p.idTPservicio}
                    >
                      <div className="row justify-content-between align-items-md-center btn-reveal-trigger border-translucent gx-0 flex-1">
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="mb-1 mb-md-0 d-flex align-items-center lh-1">
                            <label className="form-check-label mb-1 mb-md-0 mb-xl-1 mb-xxl-0 fs-8 me-2 line-clamp-1 text-body">
                              {p.descripcion}
                            </label>
                            <button className="badge badge-phoenix ms-auto fs-10 badge-phoenix-info" disabled={true} style={{display:"none"}}>
                              editar
                            </button>
                            <button className="badge badge-phoenix ms-auto ms-2 fs-10 badge-phoenix-danger rounded-4" onClick={()=>{deleteTPServicio(p.idTPservicio)}}>
                              eliminar
                            </button>
                          </div>
                        </div>
                        <div className="col-12 col-md-auto col-xl-12 col-xxl-auto">
                          <div className="d-flex lh-1 align-items-center">
                            <div className="hover-md-hide hover-xl-show hover-xxl-hide">
                              <p className="text-body-tertiary fs-10 fw-bold mb-md-0 mb-0 ps-md-3 ps-xl-0 ps-xxl-3 border-start-md border-xl-0 border-start-xxl">
                                {p.tipo}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
              <div className="card-footer border-0">
                <a
                  className="fw-bold fs-9 mt-4"
                  data-bs-toggle="modal"
                  data-bs-target="#modalAgregarTPServicio"
                >
                  <span className="fas fa-plus me-1"></span>Agregar nueva clasificación
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAgregarCategoria"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef1}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de categoria
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendCategoria}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Nombre de categoria</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form1.register("nombre",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}/>
                  { form1.formState.errors?.nombre && <code>{form1.formState.errors.nombre.message}</code> } 
                </div>                
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="modalAgregarTPServicio"
        tabIndex="-1"
        aria-labelledby="verticallyCenteredModalLabel"
        aria-hidden="true"
        ref={modalRef2}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-header">
              <h5 className="modal-title" id="verticallyCenteredModalLabel">
                Datos de clasificación
              </h5>
              <button
                className="btn p-1"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span className="fas fa-times fs-9"></span>
              </button>
            </div>
            <form onSubmit={sendTPServicio}>
              <div className="modal-body">
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Nombre de clasificación</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form2.register("descripcion",{
                    required: {
                      value: true,
                      message: "Este campo es obligatorio"
                    }
                  })}/>
                  { form2.formState.errors?.descripcion && <code>{form2.formState.errors.descripcion.message}</code> } 
                </div>  
                <div className="mb-2">
                  <label className="form-label" htmlFor="exampleFormControlInput">Tipo de clasificación(Opcional)</label>
                  <input className="form-control rounded-4" id="exampleFormControlInput" type="text" {...form2.register("tipo",{
                    maxLength: {
                      value: 1,
                      message: "Solo debes ingresar un caracter que identifique a la clasificación"
                    }
                  })}/>
                  { form2.formState.errors?.tipo && <code>{form2.formState.errors.tipo.message}</code> } 
                </div>                
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Registrar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}


